"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISO_3166_1_alpha_2_unsupportedCodes = void 0;
/**
 * ISO 3166-1 alpha-2 country codes that we don’t support
 */
exports.ISO_3166_1_alpha_2_unsupportedCodes = ['AQ', 'BQ', 'SH'];
